import { useCallback, useEffect, useState } from "react";

const LS_KEY = "dfo.hideAmounts";

function readSaved(): boolean {
  try {
    return window.localStorage.getItem(LS_KEY) === "1";
  } catch {
    return false;
  }
}

/**
 * "Hide balances" privacy mode. Toggling flips body.dag-hide-amounts, which the
 * scoped CSS uses to blur every `.dag-amount` figure until hovered. The choice
 * is remembered across sessions — a fitting default control for a family office.
 */
export function usePrivacyMode(): { hidden: boolean; toggle: () => void } {
  const [hidden, setHidden] = useState<boolean>(readSaved);

  const toggle = useCallback(() => setHidden((prev) => !prev), []);

  useEffect(() => {
    document.body.classList.toggle("dag-hide-amounts", hidden);
    try {
      window.localStorage.setItem(LS_KEY, hidden ? "1" : "0");
    } catch {
      /* storage disabled — ignore */
    }
    // Clear the blur if the controls unmount (e.g. logout → page without a navbar),
    // otherwise figures would stay blurred with no toggle to reveal them.
    return () => document.body.classList.remove("dag-hide-amounts");
  }, [hidden]);

  return { hidden, toggle };
}
